import { Skeleton } from '@/components/ui/skeleton';

export function TimelineRowSidebarSkeleton() {
  return (
    <div className="flex max-w-48 flex-col items-start gap-2 overflow-hidden">
      <div className="flex items-start gap-1.5">
        <Skeleton className="h-8 w-8 flex-shrink-0 rounded-lg" />
        <div className="flex flex-1 flex-col gap-2.5">
          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-2 w-16" />
          </div>
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-2 w-20" />
            <Skeleton className="h-2 w-20" />
            <Skeleton className="h-2 w-20" />
          </div>
        </div>
      </div>
    </div>
  );
}
